import { render, staticRenderFns } from "./EventTicketDetailSidebar.vue?vue&type=template&id=79b8aa9e&scoped=true&"
import script from "./EventTicketDetailSidebar.vue?vue&type=script&lang=js&"
export * from "./EventTicketDetailSidebar.vue?vue&type=script&lang=js&"
import style0 from "./EventTicketDetailSidebar.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./EventTicketDetailSidebar.vue?vue&type=style&index=1&id=79b8aa9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b8aa9e",
  null
  
)

export default component.exports